import { z } from 'zod';
export const LocalProviderConfigSchema = z.object({
    enabled: z.boolean().default(true),
});
export const GoogleDriveProviderConfigSchema = z.object({
    enabled: z.boolean().default(false),
    clientId: z.string().optional(),
    scope: z
        .string()
        .default('https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/userinfo.email'),
    /** Drive folder ID of the SKJV root folder. Set after first connect + folder create. */
    folderId: z.string().optional(),
    /** Google account email captured at Connect time. Used for divergence detection. */
    email: z.string().optional(),
});
export const StorageConfigSchema = z.object({
    providers: z
        .object({
        local: LocalProviderConfigSchema.default({ enabled: true }),
        'google-drive': GoogleDriveProviderConfigSchema.default({ enabled: false }),
    })
        .passthrough()
        .default({
        local: { enabled: true },
        'google-drive': {
            enabled: false,
            scope: 'https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/userinfo.email',
        },
    }),
    readRepair: z.enum(['off', 'on-read', 'once-per-session']).default('once-per-session'),
});
export const DEFAULT_STORAGE_CONFIG = StorageConfigSchema.parse({});
//# sourceMappingURL=storage-config-schema.js.map